/** Marca gráfica de la aplicación: un plano arquitectónico simplificado. Reutiliza el mismo diseño del favicon (public/favicon.svg). */
export default function BrandMark({ size = 32 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="2" width="28" height="28" rx="6" fill="#e6efec" />
      <path
        d="M8 8H24V24H8V8Z"
        stroke="#2f6f5e"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path d="M8 17H17V24" stroke="#2f6f5e" strokeWidth="1.6" strokeLinejoin="round" />
      <path d="M17 8V17" stroke="#2f6f5e" strokeWidth="1.6" strokeLinejoin="round" />
      <circle cx="17" cy="17" r="1.6" fill="#2f6f5e" />
    </svg>
  )
}
